import { ActionIcon, Group, Tooltip } from '@mantine/core'
import { IconPencil, IconReload, IconTrash } from '@tabler/icons-react'
import { useIntl } from 'react-intl'
import { useHasPermissions } from '@/permissions/useHasPermissions'
import { CrossCameraPipeline } from '@/types/crossCamera'
import { CrudAction, Resource } from '@/types/permissions'

type CrossCameraPipelineListActionsProps = {
  pipeline: CrossCameraPipeline
  onEdit: (pipeline: CrossCameraPipeline) => void
  onDelete: (pipeline: CrossCameraPipeline) => void
  onRestart: (pipeline: CrossCameraPipeline) => void
}

export const CrossCameraPipelineListActions = ({
  pipeline,
  onEdit,
  onDelete,
  onRestart
}: CrossCameraPipelineListActionsProps) => {
  const intl = useIntl()
  const [canUpdate] = useHasPermissions(Resource.Applications, [
    CrudAction.Update
  ])

  const editLabel = intl.formatMessage({
    id: 'crossCamera.pipelines.actions.edit'
  })
  const restartLabel = intl.formatMessage({
    id: 'crossCamera.pipelines.actions.restart'
  })
  const deleteLabel = intl.formatMessage({
    id: 'crossCamera.pipelines.actions.delete'
  })

  return (
    <Group wrap="nowrap" gap={8} justify="end">
      {canUpdate && (
        <Tooltip label={editLabel}>
          <ActionIcon
            variant="outline"
            size="md"
            radius="sm"
            color="blue"
            aria-label={editLabel}
            onClick={() => onEdit(pipeline)}
          >
            <IconPencil style={{ width: '70%', height: '70%' }} />
          </ActionIcon>
        </Tooltip>
      )}

      {canUpdate && (
        <Tooltip label={restartLabel}>
          <ActionIcon
            variant="outline"
            size="md"
            radius="sm"
            color="gray"
            aria-label={restartLabel}
            onClick={() => onRestart(pipeline)}
          >
            <IconReload style={{ width: '70%', height: '70%' }} />
          </ActionIcon>
        </Tooltip>
      )}

      {canUpdate && (
        <Tooltip label={deleteLabel}>
          <ActionIcon
            variant="outline"
            size="md"
            radius="sm"
            color="red"
            aria-label={deleteLabel}
            onClick={() => onDelete(pipeline)}
          >
            <IconTrash style={{ width: '70%', height: '70%' }} />
          </ActionIcon>
        </Tooltip>
      )}
    </Group>
  )
}
